import handleRouteChange from './handleRouteChange';
import handleUserType from './handleUserType';
import initFlowConfig from './initFlowConfig';
import redirectLoggedInUser from './redirectLoggedInUser';
import reportPerformance from './reportPerformance';
import startPPF from './startPPF';
import trackPageview from './trackPageview';
import trackClickedPixel from './trackClickedPixel';
import trackVisit from './trackVisit';
import trackNavbar from './trackNavbar';

export default {
  redirectLoggedInUser,
  reportPerformance,
  handleRouteChange,
  handleUserType,
  initFlowConfig,
  startPPF,
  trackPageview,
  trackClickedPixel,
  trackNavbar,
  trackVisit
};
